<template>
  <div class="page">
    <div class="container">
      <div class="header">
        <span>溯源码查询结果</span>
      </div>

      <!--———— 产品信息 ——————-->
      <div class="product round-card">
        <div class="product-info">
          <div>
            <div class="product-name">黄梅稻田清水龙虾</div>
            <div class="product-attribute">
              500g/盒&nbsp; • &nbsp;4-5钱&nbsp; • &nbsp;生态稻虾共作
            </div>
          </div>
          <div class="product-tag">品质认证</div>
        </div>
        <div class="picture">
          <img src="../assets/product.png" alt="" />
        </div>

        <div class="product-trace">
          <div class="trace-info">
            <div class="trace-no">
              <div class="label">溯源批次号</div>
              <div class="number">HM20260729001</div>
            </div>

            <div class="trace-date">
              <div class="label">生产日期</div>
              <div class="number">2026-07-29</div>
            </div>
          </div>

          <div class="copy-btn">复制溯源编号</div>
        </div>
      </div>

      <!--———— 主体信息 ——————-->
      <div class="company round-card">
        <div class="company-title flex">
          生产主体信息
          <div class="line"></div>
        </div>

        <div class="company-info flex">
          <div class="company-label flex">
            <span><img src="../assets/zhuti/zhuti.png" alt="icon" /></span>
            <span>企业名称</span>
          </div>
          <div class="company-value">湖北黄梅水产农业发展有限公司</div>
        </div>

        <div class="line"></div>

        <div class="company-info flex">
          <div class="company-label flex">
            <span><img src="../assets/zhuti/code.png" alt="icon" /></span>
            <span>统一信用代码</span>
          </div>
          <div class="company-value">9142XXXXXXXXXX</div>
        </div>

        <div class="line"></div>

        <div class="company-info flex">
          <div class="company-label flex">
            <span><img src="../assets/zhuti/address.png" alt="icon" /></span>
            <span>企业地址</span>
          </div>
          <div class="company-value">湖北省黄梅县生态水产产业园</div>
        </div>

        <div class="line"></div>

        <div class="company-info flex">
          <div class="company-label flex">
            <span><img src="../assets/zhuti/unit.png" alt="icon" /></span>
            <span>生产基地</span>
          </div>
          <div class="company-value">黄梅县小溪山生态养殖基地</div>
        </div>

        <div class="line"></div>

        <div class="company-info flex">
          <div class="company-label flex">
            <span><img src="../assets/zhuti/base.png" alt="icon" /></span>
            <span>生产单元</span>
          </div>
          <div class="company-value">01号稻虾共作水塘</div>
        </div>
      </div>

      <!--———— 承诺信息 ——————-->
      <div class="promise flex">
        <div class="promise-card round-card">
          <div class="promise-icon flex">
            <img src="../assets/prove.png" alt="icon" />
          </div>
          <div class="promise-title">主体认证</div>
          <div class="promise-subtitle">认证有效</div>
        </div>

        <div class="promise-card round-card">
          <div class="promise-icon">
            <img src="../assets/prove.png" alt="icon" />
          </div>
          <div class="promise-title">基地可查</div>
          <div class="promise-subtitle">实地核验</div>
        </div>

        <div class="promise-card round-card">
          <div class="promise-icon">
            <img src="../assets/prove.png" alt="icon" />
          </div>
          <div class="promise-title">来源可信</div>
          <div class="promise-subtitle">溯源保障</div>
        </div>
      </div>

      <!--———— 溯源详情 ——————-->
      <div class="trace-container">
        <div class="title-wrap">
          <span class="title-icon">⥁</span>
          <h3>全流程溯源</h3>
        </div>

        <!-- 外层：自定义时间轴 -->
        <div class="trace-timeline">
          <!-- 每个大阶段循环 -->
          <div class="timeline-phase" v-for="phase in fakeTraceData" :key="phase.id">
            <!-- 左侧圆点 + 竖线容器 -->
            <div class="timeline-axis">
              <div class="timeline-dot"></div>
              <!-- 不是最后一个阶段，显示向下竖线 -->
              <div class="timeline-line"></div>
            </div>

            <!-- 右侧折叠卡片：一个阶段，内部包含多条溯源记录 -->
            <div class="timeline-card-wrap">
              <div class="card-header">
                <span class="stage-tag">{{ phase.stageName }}</span>
              </div>

              <!-- 展开区域：【一个阶段内多条溯源节点】 -->
              <div class="phase-inner-list">
                <div class="record-item" v-for="record in phase.recordList" :key="record.id">
                  <div class="record-time">
                    <span class="date-text">{{ record.date }}</span>
                    <span class="record-title">{{ record.title }}</span>
                    <span v-if="record.image" @click="record.showPic = !record.showPic">
                      <i v-if="record.showPic" class="el-icon-arrow-up arrow-icon"></i>
                      <i v-else class="el-icon-arrow-down arrow-icon"></i>
                    </span>
                  </div>

                  <div v-if="record.image && record.showPic" class="record-desc-row">
                    <el-image
                      class="record-img"
                      :src="record.image"
                      fit="cover"
                      :preview-src-list="[record.image]"></el-image>

                    <div class="record-desc">{{ record.desc }}</div>
                  </div>

                  <div v-if="!record.showPic" class="record-desc">
                    {{ record.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--———— 品牌信息 ——————-->
      <div class="brand">
        <div class="brand-title flex">
          <span class="title-line"></span>
          <span>品牌故事</span>
        </div>

        <div class="brand-content">
          源自黄梅水乡，依托清洁水源与生态稻虾共作模式，坚持自然生长周期，打造安全、新鲜、可溯源的高品质水产。
        </div>

        <div class="brand-tags flex">
          <div class="tag">
            <img src="" alt="" />
            <span>官方溯源认证</span>
          </div>

          <div class="tag">
            <img src="" alt="" />
            <span>地理标志产品</span>
          </div>

          <div class="tag">
            <img src="" alt="" />
            <span>绿色食品</span>
          </div>
        </div>

        <div class="brand-image"></div>
      </div>

      <!--———— footer ——————-->
      <div class="footer">
        <div class="footer-title">黄梅水产数字智慧供应链平台</div>
        <div class="footer-subtitle">技术支持 · 数据安全 · 全程可信</div>
        <div class="footer-name">© 2026湖北黄梅水产农业发展有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTraceData } from '@/api/getData'

export default {
  data() {
    return {
      // 默认展开第一项
      activeCollapse: [0],

      code: 'SY1787626952060477299434',
      type: '1', // 1:溯源， 2：产品

      traceDetail: [],

      // ====== 假数据：一个阶段包含多条溯源节点 ======
      fakeTraceData: [
        {
          id: '1',
          stageName: '阶段1：苗种与投放',
          recordList: [
            {
              id: '1001',
              date: '2026-04-10',
              title: '苗种投放',
              desc: '投放优质虾苗50,000尾，水质监测正常',
              image: 'https://picsum.photos/id/1037/600/400',
              showPic: false
            },
            {
              id: '1002',
              date: '2026-04-15',
              title: '首次水质巡检',
              desc: '水体溶氧量达标，无病害预警',
              image: 'https://picsum.photos/id/1043/600/400',
              showPic: false
            }
          ]
        },
        {
          id: '2',
          stageName: '阶段2：生态养殖与投喂',
          recordList: [
            {
              id: '2001',
              date: '2026-05-15',
              title: '定期投喂与水质调控',
              desc: '使用有机复合蛋白饲料，水质透明度35cm',
              image: 'https://picsum.photos/id/1039/600/400',
              showPic: false
            },
            {
              id: '2002',
              date: '2026-06-20',
              title: '生长抽样检测',
              desc: '虾体规格达标，持续生态养护',
              image: 'https://picsum.photos/id/1041/600/400',
              showPic: false
            }
          ]
        },
        {
          id: '3',
          stageName: '阶段3：捕捞与质检',
          recordList: [
            {
              id: '3001',
              date: '2026-07-28',
              title: '捕捞出塘与抽样质检',
              desc: '检测结果合格，支持查看质检报告',
              image: 'https://picsum.photos/id/1038/600/400',
              showPic: false
            }
          ]
        },
        {
          id: '4',
          stageName: '阶段4：分选打包出库',
          recordList: [
            {
              id: '4001',
              date: '2026-07-29',
              title: '冷链打包出库',
              desc: '完成分选、包装、贴码、冷链运输',
              image: '',
              showPic: false
            },
            {
              id: '4002',
              date: '2026-07-30',
              title: '物流中转登记',
              desc: '冷链温度全程监控，正常转运',
              image: '',
              showPic: false
            }
          ]
        }
      ]
    }
  },

  created() {
    // this.code = this.getParameterByName('code')
    // this.type = this.getParameterByName('type')

    this.fetchTraceData()
  },

  methods: {
    // 解析URL
    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      //匹配所有符合条件的，并取最后一个
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'g')
      var results = url.match(regex)
      var tempResults =
        results != null && results[results.length - 1] != undefined
          ? results[results.length - 1]
          : ''
      var finalResults = regex.exec(tempResults)
      if (!finalResults) return ''
      if (!finalResults[2]) return ''
      return decodeURIComponent(finalResults[2].replace(/\+/g, ' '))
    },

    async fetchTraceData() {
      try {
        const params = {
          code: this.code,
          type: this.type
        }
        const res = await getTraceData(params)

        if (res.resultCode == 1) {
          this.traceDetail = res.resultInfo.info
        }
        console.log('溯源数据:', res.data)
      } catch (error) {
        console.error('获取溯源数据失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
// [v-cloak] {
//   display: none;
// }

// ————— 公共类 ——————————————————
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.round-card {
  border-radius: 2rem;
  background: #fff;
  padding: 2rem 3rem;
  // max-width: 64rem;
  width: calc(100% - 4rem); /* 左右预留2rem空间 */
  margin: 1.5rem auto;
  box-sizing: border-box;
  border: 1px solid #f0f6f0;
}

// ————————————————————————————————————
.page {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #f0f7f0;
  background-size: 100% 100%;
  // overflow: hidden;
  padding: 0 15%;
  position: relative;
}

.container {
  background: #f0f7f0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.header {
  margin: 2rem 0;
  text-align: center;

  span {
    background: #cfeada;
    color: #035503;
    font-size: 22px;
    font-weight: 500;
    padding: 1.2rem 1.6rem;
    border-radius: 1.6rem;
  }
}

.picture {
  width: 70%;
  margin: 2rem auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.product-info {
  display: flex;
  justify-content: space-between;
}

.product-name {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
  padding-bottom: 0.4rem;
}

.product-attribute {
  color: #698492;
}

.product-tag {
  background: #2a965c;
  color: #fff;
  font-size: 14px;
  height: fit-content;
  padding: 0.4rem 1rem;
  border-radius: 1.2rem;
}

.trace-info {
  background: #f3fbf6;
  border: 1px solid #d5eedf;
  border-radius: 1.2rem;
  padding: 1.2rem 1.5rem;
  margin: 1.5rem 0;
}

.trace-no,
.trace-date {
  display: flex;
  justify-content: space-between;
}

.trace-no {
  margin-bottom: 0.8rem;
}

.label {
  color: #698492;
}

.number {
  color: #1b3646;
  font-weight: 600;
  letter-spacing: 1px;
}

.copy-btn {
  background: linear-gradient(232deg, #57bf84, #3e8b5f);
  color: #fff;
  font-size: 20px;
  padding: 1rem;
  text-align: center;
  border-radius: 1.4rem;
}

// .company {
//   height: 29rem;
// }

.company-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  gap: 2rem;
  margin-bottom: 1.5rem;
}

.line {
  flex: 1;
  height: 1px;
  background: #e8f0e9;
}

.company-info {
  justify-content: flex-start;
  gap: 6rem;
  margin: 1.5rem 0;
}

.company-label {
  width: 12rem;
  color: #608267;
  justify-content: left;
  gap: 6px;

  img {
    width: 1.8rem;
    height: auto;
    padding-top: 4px;
  }
}

.company-value {
  color: #132f1b;
  font-weight: 500;
}

.promise {
  justify-content: space-around;
}

.promise-card {
  background: #eaf7ef;
  border: 1px solid #cbebd8;
  padding: 2rem 4rem;
  text-align: center;
  width: auto;
}

.promise-icon {
  img {
    height: 32px;
    width: 32px;
  }
}

.promise-title {
  color: #2e9f61;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.promise-subtitle {
  color: #64808f;
  font-size: 13px;
}

// ———— 溯源时间轴 —————————————————
.trace-container {
  background-color: #f0f9f2;
  padding: 2.4rem 2rem;
  border-radius: 1.6rem;
}
.title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
  padding-bottom: 8px;
  border-bottom: 1px solid #d6e9dc;
}
.title-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e1f3e8;
  border-radius: 50%;
  color: #399e5a;
  font-size: 18px;
}
.title-wrap h3 {
  margin: 0;
  font-size: 20px;
  color: #222;
}

/* 时间轴外层 */
.trace-timeline {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.timeline-phase {
  display: flex;
  gap: 14px;
}
/* 左侧圆点竖线 */
.timeline-axis {
  flex-shrink: 0;
  width: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #399e5a;
  margin-top: 0.8rem;
}
.timeline-line {
  width: 2px;
  flex: 1;
  background-color: #399e5a;
  margin-top: 4px;
}
.timeline-card-wrap {
  flex: 1;
}

/* 覆盖折叠面板默认样式 */
/deep/ .el-collapse {
  border: none;
}
/deep/ .el-collapse-item {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(57, 158, 90, 0.08);
}
/deep/ .el-collapse-item__header {
  background: #fff;
  height: auto;
  padding: 16px 20px;
  border: none;
}
/deep/ .el-collapse-item__wrap {
  border: none;
}
/deep/ .el-collapse-item__content {
  padding: 0 20px 20px;
}

.card-header {
  display: flex;
  align-items: center;
}
.stage-tag {
  background: #078739;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 600;
}

/* 阶段内部多条记录 */
.phase-inner-list {
  // border-top: 1px solid #e8efeb;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.record-item {
  background: #fff;
  border-radius: 16px;
  padding: 1rem 1.8rem;
}
.record-time {
  margin-bottom: 8px;
}
.date-text {
  font-size: 16px;
  color: #399e5a;
  font-weight: 600;
}
.arrow-icon {
  float: right;
  margin-right: 1rem;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
}

.record-title {
  font-size: 16px;
  color: #222;
  margin-left: 1.6rem;
  font-weight: bold;
}
.record-desc-row {
  display: flex;
  gap: 1.6rem;
  align-items: flex-start;
}
.record-img {
  width: 16rem;
  height: 12rem;
  border-radius: 12px;
  flex-shrink: 0;
}
.record-desc {
  font-size: 16px;
  color: #567764;
  line-height: 1.6;
}

// ———— 品牌信息 ————————————————————
.brand {
  background: linear-gradient(180deg, #e1efe3, #ffffff24);
  border-top: 1px solid #deede0;
  padding: 1.2rem 1.8rem 2rem 1.8rem;
  margin-top: 3rem;
}

.brand-title {
  justify-content: left;
  gap: 8px;
  color: #193521;
  font-weight: 600;
}

.title-line {
  height: 16px;
  width: 4px;
  border-radius: 6px;
  background: #398b47;
}

.brand-content {
  color: #5a7e62;
  font-size: 14px;
  line-height: 2.6rem;
  margin: 1rem 0;
}

.brand-tags {
  justify-content: left;
  gap: 15px;
}

.tag {
  background: #e5f0e6;
  border: 1px solid #b8debe;
  padding: 2px 8px;
  border-radius: 14px;
  font-size: 14px;
  color: #2d7a3a;
}

.footer {
  background: #1f7a4c;
  text-align: center;
  margin-top: 3rem;
  padding: 5rem 0;
}

.footer-title {
  margin-bottom: 1.2rem;
  color: #c7ded2;
  font-size: 14px;
}

.footer-subtitle {
  color: #77af93;
  font-size: 13px;
  margin-bottom: 1rem;
}

.footer-name {
  color: #77af93;
  font-size: 13px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .page {
    padding: 0; // 清除桌面端15%边距
  }

  .round-card {
    padding: 1.4rem 1.6rem; // 缩小卡片内边距
  }

  .product-tag {
    font-size: 11px;
  }

  .promise {
    // flex-direction: column;
    gap: 1rem;
  }

  .record-desc-row {
    flex-direction: column;
  }
  .record-img {
    width: 100%;
    height: auto;
  }

  .date-text {
    font-size: 14px;
  }

  .timeline-phase {
    gap: 10px;
  }

  .company-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.6rem;
  }
  .company-label {
    width: auto; // 取消固定宽度
  }

  .header span {
    font-size: 18px;
  }
  .product-name {
    font-size: 18px;
  }
  .copy-btn {
    font-size: 18px;
  }
}
</style>
